import { render, staticRenderFns } from "./BodyList.vue?vue&type=template&id=067f3e73&scoped=true&"
import script from "./BodyList.vue?vue&type=script&lang=js&"
export * from "./BodyList.vue?vue&type=script&lang=js&"
import style0 from "./BodyList.vue?vue&type=style&index=0&id=067f3e73&lang=stylus&scoped=true&"
import style1 from "./BodyList.vue?vue&type=style&index=1&lang=stylus&"
import style2 from "./BodyList.vue?vue&type=style&index=2&id=067f3e73&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067f3e73",
  null
  
)

export default component.exports